/** In this file contains the landing page UI designs and functionality **/
import constantVariables from './../../dataset/constantVariables.json';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

//Landing or Home page
export default function Clinics(){
	
	/** To check the token exist or not **/
   useEffect(()=>{
	  const section = document.getElementById("indexPage");
		if (section) {
		  section.scrollIntoView({ behavior: 'smooth' });
		}
   },[]);
   
	return (
	<> <div id="indexPage">
	{/*Breadcrumb Section*/}
		<section id="BreadcrumbSec" className="d-flex align-items-center justify-content-center" style={{background: "url(assets/img/breadcrumb-banner-img3.jpg)top left"}}>
			<div className="container">
				<div className="row d-flex">
					<div className="col-lg-12 align-items-center">
						<h1>{constantVariables.landing.clinics}</h1>
					</div>
				</div>
			</div>
		</section>
			
			{/*Section 01*/}
		<section className="section">
			<div className="container">
				<div className="row"> 
					<div className="col-lg-12"> 
						<div className="subpgImgBox-blue"> 
							<div className="row">
							  <div className="col-lg-6">
								  <div className="subpgContent mt-lg-5">
									<h3>{constantVariables.landing.clin1}</h3>
									<p><b>Seamless Growth Tracking Integration:</b> With Nurture, access a child's growth history at a glance, enabling you to assess growth patterns over time efficiently. This feature provides a comprehensive view of a child's physical development, assisting in early detection of potential health issues.</p>
									
									<a href="#parentsPgSec2" className="btn btn-tmPink px-4 h4 mt-3">{constantVariables.landing.getStarted}</a>
								  </div>
							  </div>
							  <div className="col-lg-6">
								 <div className="tp-payment__shape-2">
									<img src="assets/img/image2a.png" alt="IMG" />
								 </div>
								 <div className="tp-payment__shape-3 d-none d-sm-block">
									<img src="assets/img/image2b.png" alt="IMG" />
								 </div>
							  </div>
						   </div>
						</div>	
					</div>	
				</div>
			</div>
		</section>
		
		{/*Section 02*/}
		<section className="section"  id="parentsPgSec2">	
			<div className="container">		 
				<div className="row pb-3"> 			 
					<div className="col-lg-6 pe-lg-5"> 
						<div className="animtionBox1">
							<div className="ab1-img01">
							  <img src="assets/img/subpg/animtionBox1-img1.jpg" alt="IMG" />
							</div>
							<div className="ab1-img02">
							  <img src="assets/img/subpg/animtionBox1-img2.jpg" alt="IMG" />
							</div>
							<div className="ab1-img03">
							  <img src="assets/img/subpg/animtionBox1-img3.jpg" alt="IMG" />
							</div>
						</div> 
					</div> 
					<div className="col-lg-6 ps-lg-5">  
						<div className="ms-lg-5">
							<div className="sectionTitle">
								<h5>{constantVariables.sidebar.vaccination}</h5>
								<h4>{constantVariables.landing.clin3}</h4>
							</div>
							 <div className="subpgContent">
								<p>{constantVariables.landing.clin4}</p>
							</div>	
						</div>	
					</div>
				</div>	
				<hr style={{background: "#888"}} />			
			</div>
		</section>
		
		{/*Section 03*/}
		<section className="section">	
			<div className="container">		 
				<div className="row pb-3"> 
					<div className="col-lg-6 pe-lg-5">  
						<div className="me-lg-5">
							<div className="sectionTitle">
								<h5 className="blueDot">{constantVariables.landing.milestones}</h5>
								<h4>{constantVariables.landing.clin5}</h4>
							</div>
							 <div className="subpgContent">
								<p>{constantVariables.landing.clin6}</p>
							</div>	
						</div>	
					</div>			 
					<div className="col-lg-6 ps-lg-5"> 
						<div className="animtionBox2">
							<div className="ab2-img01">
							  <img src="assets/img/subpg/animtionBox2-img1.jpg" alt="IMG" />
							</div>
							<div className="ab2-img02">
							  <img src="assets/img/subpg/animtionBox2-img2.jpg" alt="IMG" />
							</div>
							<div className="ab2-img03">
							  <img src="assets/img/subpg/animtionBox2-img3.jpg" alt="IMG" />
							</div>
						</div> 
					</div> 
				</div>	
				<hr style={{background: "#888"}} />		
			</div>
		</section>
		
		{/*Section 04*/}
		<section className="section">	
			<div className="container">		 
				<div className="row pb-3"> 			 
					<div className="col-lg-6 pe-lg-5"> 
						<div className="animtionBox1">
							<div className="ab1-img01">
							  <img src="assets/img/subpg/animtionBox3-img1.jpg" alt="IMG" />
							</div>
							<div className="ab1-img02">
							  <img src="assets/img/subpg/animtionBox3-img2.jpg" alt="IMG" />
							</div>
							<div className="ab1-img03">
							  <img src="assets/img/subpg/animtionBox3-img3.jpg" alt="IMG" />
							</div>
						</div> 
					</div> 
					<div className="col-lg-6 ps-lg-5">  
						<div className="ms-lg-5">
							<div className="sectionTitle">
								<h5>{constantVariables.landing.medicalHistory}</h5>
								<h4>{constantVariables.landing.clin7}</h4>
							</div>
							 <div className="subpgContent">
								<p>{constantVariables.landing.clin8}</p>
							</div>	
						</div>	
					</div>
				</div>	
				<hr style={{background: "#888"}} />			
			</div>
		</section>
		
		{/*Section 05*/}
		<section className="section">	
			<div className="container">		 
				<div className="row pb-3"> 
					<div className="col-lg-6 pe-lg-5">  
						<div className="me-lg-5">
							<div className="sectionTitle">
								<h5 className="blueDot">{constantVariables.landing.sharing}</h5>
								<h4>{constantVariables.landing.clin9}</h4>
							</div>
							 <div className="subpgContent">
								<p>{constantVariables.landing.clin10}</p>
							</div>	
						</div>	
					</div>			 
					<div className="col-lg-6 ps-lg-5"> 
						<div className="animtionBox2">
							<div className="ab2-img01">
							  <img src="assets/img/subpg/animtionBox4-img1.jpg" alt="IMG" />
							</div>
							<div className="ab2-img02">
							  <img src="assets/img/subpg/animtionBox4-img2.jpg" alt="IMG" />
							</div>
							<div className="ab2-img03">
							  <img src="assets/img/subpg/animtionBox4-img3.jpg" alt="IMG" />
							</div>
						</div> 
					</div> 
				</div>
				<hr style={{background: "#888"}} />		
			</div>
		</section>
		
		{/*Section 06*/}
		<section className="section">	
			<div className="container">		 
				<div className="row pb-3"> 			 
					<div className="col-lg-6 pe-lg-5"> 
						<div className="animtionBox1">
							<div className="ab1-img01">
							  <img src="assets/img/subpg/animtionBox5-img1.jpg" alt="IMG" />
							</div>
							<div className="ab1-img02">
							  <img src="assets/img/subpg/animtionBox5-img2.jpg" alt="IMG" />
							</div>
							<div className="ab1-img03">
							  <img src="assets/img/subpg/animtionBox5-img3.jpg" alt="IMG" />
							</div>
						</div> 
					</div> 
					<div className="col-lg-6 ps-lg-5">  
						<div className="ms-lg-5">
							<div className="sectionTitle">
								<h5>{constantVariables.landing.communication}</h5>
								<h4>{constantVariables.landing.clin11}</h4>
							</div>
							 <div className="subpgContent">
								<p>{constantVariables.landing.clin12}</p>
							</div>	
						</div>	
					</div>
				</div>	
				<hr style={{background: "#888"}} />
			</div>
		</section>
		
		{/*Section 07*/}
		<section className="section pt-2">	
			<div className="container">		 
				<div className="row pb-3"> 
					<div className="col-lg-8 mx-auto text-center">  
						<div className="sectionTitle center">
							<h5>{constantVariables.landing.nurture}</h5>
							<h4>{constantVariables.landing.clin13}</h4>
						</div>
						 <div className="subpgContent pe-5 ">
							<p>{constantVariables.landing.clin14}</p>
						</div>	
						<Link to='/request' className="btn btn-tmBlue btn-lg px-5 py-3 rounded-pill mt-4"> {constantVariables.landing.requestDemo} </Link>	
					</div>	
				</div>		
			</div>
		</section>
	</div></>);
}